import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { DataGroupCopyEntity } from "../../types/DataGroupCopyEntity";
import type { DataGroupEntity } from "../../types/DataGroupEntity";
import { DataGroupCopyEntityToCopyDto } from "../mappers/DataGroupCopyEntityToCopyDto";
import { DataGroupDtoToEntity } from "../mappers/DataGroupDtoToEntity";
import { DataGroupEntityToDto } from "../mappers/DataGroupEntityToDto";

const DataGroupApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        DataGroupLoad: builder.query<DataGroupEntity, FormQuery>({
            providesTags: [ResourceName.DATA_GROUPS],
            query: (queryParams) => {
                return {
                    url: `${ResourceName.DATA_GROUPS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return DataGroupDtoToEntity(response);
            },
        }),
        DataGroupSave: builder.mutation<DataGroupEntity, FormMutation<DataGroupEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.DATA_GROUPS}`;
                const method = "POST";

                const body = DataGroupEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DATA_GROUPS],
        }),
        DataGroupUpdate: builder.mutation<DataGroupEntity, FormMutation<DataGroupEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.DATA_GROUPS}/${mutation.data.id}`;
                const method = "PUT";

                const body = DataGroupEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DATA_GROUPS],
        }),
        DataGroupCopy: builder.mutation<DataGroupEntity, FormMutation<DataGroupCopyEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.DATA_GROUPS}/${mutation.data.id}/${FORM_ACTION.COPY}`;
                const method = "POST";

                const body = DataGroupCopyEntityToCopyDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DATA_GROUPS],
        }),
    }),
});

export const { useDataGroupLoadQuery, useDataGroupSaveMutation, useDataGroupUpdateMutation, useDataGroupCopyMutation } = DataGroupApi;
